import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class HttpService {
    constructor(private httpClient: HttpClient) {}

    private getHeaderOptions(): {} | undefined {
        let uuid: string | null = localStorage.getItem("uuid");

        if (uuid) {
            return {
                headers: new HttpHeaders({
                    "uuid": uuid
                })
            };
        }

        return undefined;
    }

    public get<T>(url: string, isExternal: boolean = false): Observable<T> {
        if (isExternal) {
            return this.httpClient.get<T>(url);
        }

        return this.httpClient.get<T>(url, this.getHeaderOptions());
    }

    public post<T>(url: string, data: any): Observable<T> {
        return this.httpClient.post<T>(url, data, this.getHeaderOptions());
    }

    public put<T>(url: string, data: any): Observable<T> {
        return this.httpClient.post<T>(url, data, this.getHeaderOptions());
    }

    public delete<T>(url: string): Observable<T> {
        return this.httpClient.delete<T>(url, this.getHeaderOptions());
    }
}